<!--
 * @Descripttion: '登录页面'
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-16 17:09:44
 * @LastEditTime: 2020-07-27 10:32:51
-->
<template>
  <div class="login-content">
    <div class="login-container">
      <div class="left-box">
        <p>法制日报政法展</p>
      </div>
      <div class="login-right">
        <Form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          label-position="left"
          :label-width="80">
          <FormItem label="登录名" prop="username">
            <Input
              v-model="formValidate.username"
              placeholder="请输入用户名"
              @keyup.enter.native="handleSubmit('formValidate')"></Input>
          </FormItem>
          <FormItem label="密码" prop="password">
            <Input
              type="password"
              v-model="formValidate.password"
              placeholder="请输入密码"
              @keyup.enter.native="handleSubmit('formValidate')"></Input>
          </FormItem>
          <!-- <Row>
            <Col span="14">
              <FormItem label="验证码" prop="code">
                <Input
                  v-model="formValidate.code"
                  placeholder="请输入验证码"
                  @keyup.enter.native="handleSubmit('formValidate')"></Input>
              </FormItem>
            </Col>
            <Col span="2">
              <div class="space" />
            </Col>
            <Col span="8">
              <div class="verification-code">验证码</div>
            </Col>
          </Row> -->
          <FormItem>
            <Button
              class="signin"
              type="primary"
              long
              v-on:keyup.enter="handleSubmit('formValidate')"
              @click="handleSubmit('formValidate')">
              <span class="loginBtn">登 录</span>
            </Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  data() {
    return {
      formValidate: {
        password: '',
        // code: '',
        username: '',
      },
      ruleValidate: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            type: 'string',
            min: 2,
            message: '用户名长度需大于2',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            type: 'string',
            min: 6,
            message: '密码长度需大于6',
            trigger: 'blur',
          },
        ],
        // code: [
        //   { required: true, message: '请输入验证码', trigger: 'blur' },
        //   {
        //     type: 'string',
        //     min: 6,
        //     message: '验证密码长度需大于6',
        //     trigger: 'blur',
        //   },
        // ],
      },
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // this.$Message.success('Success!')
          this.login(this.formValidate)
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    async login(payload) {
      payload.password = CryptoJS.MD5(payload.password).toString(CryptoJS.enc.Hex)
      await this.$store.dispatch('globe/user/doLogin', payload).then(rst => {
        if (rst.success && rst.code === '0' && rst.flag === '0') {
          this.$Message.success('登录成功')
          this.$cookies.set('sid', rst.dataResult)
          this.$store.commit('globe/user/SET_USER_NAME', this.formValidate.username)
          setTimeout(() => {
            this.$router.push('/legalDaily')
          }, 1000)
        } else {
          this.$Message.error(rst.message)
        }
      })
        .catch(error => {
          this.$Message.error(error.message)
        })
    },
  },
}
</script>

<style lang='scss' scoped>
.login-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/login.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-container {
    height: 460px;
    display: flex;
    justify-content: center;
    align-items: center;
    .left-box {
      width: 562px;
      height: 100%;
      background: url('../../assets/img/Rectangle Copy 2.png') no-repeat;
      background-size: 100% 100%;
      border-radius: 8px 0px 0px 8px;
      >p{
        text-align: center;
        font-size: 32px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: bolder;
        text-align: center;
        color: #ffffff;
        margin-top:50px;
        letter-spacing: 5px;
      }
    }
    .login-right {
      width: 460px;
      height: 100%;
      background: #ffffff;
      border-radius: 0px 8px 8px 0px;
      padding: 40px;
      .verification-code {
        height: 44px;
        background: #f2f2f2;
        text-align: center;
        line-height: 44px;
        margin-top: 35px;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
      }
      .space {
        height: 44px;
        text-align: center;
        line-height: 44px;
        margin-top: 35px;
      }
      .signin {
        width: 100%;
        height: 44px;
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #ffffff;
      }
      /deep/.ivu-form-item {
        display: flex;
        flex-direction: column;
      }
      /deep/.ivu-form-item-content {
        margin-left: 0px !important;
      }
      /deep/.ivu-form-item-label {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
      }
      /deep/.ivu-input {
        height: 45px;
      }
      /deep/.ivu-form-item-required .ivu-form-item-label:before {
        content: "*";
        display: none;
      }
    }
  }
}
</style>